import BaseGrid from "../sections/view";
import { text, roleAvatar } from "../../helpers/templates";

export default class GridView extends BaseGrid {
	config() {
		const _ = this.app.getService("locale")._;

		const ui = super.config();
		webix.extend(
			ui,
			{
				rowHeight: webix.skin.$active.rowHeight + 10,
				headerRowHeight: webix.skin.$active.barHeight + 10,
			},
			true
		);
		ui.columns = [
			{
				id: "color",
				header: "",
				width: 60,
				css: "webix_um_center_column ",
				template: roleAvatar,
			},
			{
				id: "name",
				header: _("Name"),
				fillspace: 2,
				sort: "string",
				template: text(this),
			},
		];

		return ui;
	}

	init() {
		const users = this.app.getService("local").roles(true);
		this.InitSelf(users, this.getParam("id", true));
	}

	ShowDetails(id) {
		this.getParentView().ShowDetails(id);
	}

	SearchCompare(value, role) {
		return role.name.toLowerCase().indexOf(value) > -1;
	}
}
